import React, { forwardRef } from 'react';

import { Textarea, Flex, TextareaProps } from '@chakra-ui/react';

import HelperMessage from './helper';
import Label from './label';

interface MyTextareaProps extends TextareaProps {
  label?:string
  helper?:string
  tooltip?:any
}

const TextArea = forwardRef<HTMLTextAreaElement, MyTextareaProps>(({
  label,
  isDisabled,
  helper,
  tooltip,
  isRequired,
  ...props
}, ref) => (
  <Flex
    w="100%"
    alignSelf="flex-start"
    flexDir="column">
    <Label
      isDisabled={isDisabled}
      label={label}
      isRequired={isRequired}
      tooltip={tooltip}
    />
    <Textarea
      bg="white.default"
      h="180px"
      isDisabled={isDisabled}
      _focus={{
        boxShadow: 's1',
        borderColor: 'primary.default',
      }}
      resize="horizontal"
      _disabled={{ cursor: 'not-allowed', bg: 'gray.50' }}
      isRequired={isRequired}
      ref={ref}
      {...props}
    />
    <HelperMessage
      helper={helper}
      color="gray.400"
    />
  </Flex>
));
export default TextArea;
